import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { RandomGenerator } from "../components/RandomGenerator";
import { RgBreadcrumb } from "../components/RgBreadcrumb";
import { RgExplainer } from "../components/RgExplainer";

export function RandomGeneratorPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <RgBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.rg_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.rg_intro()}
          </p>
        </header>

        <RandomGenerator />

        <RgExplainer
          howTo={m.rg_howto()}
          faqs={[
            { q: m.rg_faq1_q(), a: m.rg_faq1_a() },
            { q: m.rg_faq2_q(), a: m.rg_faq2_a() },
            { q: m.rg_faq3_q(), a: m.rg_faq3_a() },
            { q: m.rg_faq4_q(), a: m.rg_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
